import type { ReactNode } from 'react'

/**
 * One section shape for a front page: a small label, a headline, then whatever
 * the section is. Written once so the rhythm down each front page that uses it
 * is a property of the page rather than something each block re-decides.
 *
 * There is no lede. A section needing a paragraph before its first point is a
 * section whose title is not doing its job.
 */
export function Section({
  id,
  label,
  title,
  children,
}: {
  id?: string
  label: string
  title: string
  children: ReactNode
}) {
  return (
    <section className="mk-section" id={id}>
      <div className="mk-measure">
        <header className="mk-section__head">
          <p className="mk-label">{label}</p>
          <h2 className="mk-section__title">{title}</h2>
        </header>
        {children}
      </div>
    </section>
  )
}

/** One statement in a row of them: a heading and the sentence behind it. */
export function Point({
  title,
  children,
}: {
  title: string
  children: ReactNode
}) {
  return (
    <div>
      <h3 className="mk-pair__title">{title}</h3>
      <p className="mk-pair__body">{children}</p>
    </div>
  )
}
